import { AssetInformationCardModule, CustomerInformationCardModule } from '@folio/modules';

export const BrokerPolicyDashboardInsuredView = () => {
  return (
    <div className="flex flex-col gap-4">
      <CustomerInformationCardModule />
      <AssetInformationCardModule />
    </div>
  );
};
